module.exports = __webpack_public_path__ + "img/person-one.f1204247.png";